import React, {useEffect, useRef, useState} from 'react';
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UAvatar from "ubs-framework/v2/UAvatar";
import {FORMAT} from "ubs-framework/v2/common/constant";
import useSocket from "../../../../../common/hooks/useSocket";
import {api, sendData} from "../../../../../../store/actions";
import {useDispatch, useSelector} from "react-redux";
import UDateFormatter from "ubs-framework/v2/Udate-formatter";
import {Encryption, errorFocus, getName, showToastSuccess} from "ubs-framework/v2/common/function";
import ViewForm from "ubs-framework/v2/UViewSurvey";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import {getCookie} from "ubs-framework/v2/common/function";
import {EVALUATION_TYPE} from "../../../../../../common/constant";

let chkArr = [];
let scorecardArr = [];
const CandidateEvaluationForm = React.memo(() => {
    const DISPATCH = useDispatch();
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));

    const _ID = useSelector(e => e.common._id);
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _GEM = useSelector(e => e?.candidate?.giveEvaluationModal || {});

    const [loader, setLoader] = useState(true)
    const [fileLoader, setFileLoader] = useState(false)
    const [fileResponse, setFileResponse] = useState({})
    const [evaluationScore, setEvaluationScore] = useState({})
    const [questionDetail, setQuestionDetail] = useState({})
    const [questionList, setQuestionList] = useState([])
    const [EVScore, setEVScores] = useState('');
    const [EVNote, setEVNote] = useState('');
    const [evaluationType, setEvaluationType] = useState(1);
    const [showThankYou, setShowThankYou] = useState(false);
    const evaluationTypeRef = useRef(evaluationType);

    useEffect(() => {
        evaluationTypeRef.current = evaluationType;
    }, [evaluationType]);

    useEffect(() => {
        let timer;
        if (showThankYou) {
            timer = setTimeout(() => {
                setShowThankYou(false);
                handle.closeModal();
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [showThankYou]);


    const {off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|candidate-evaluation|fetch': {
                    setLoader(false)
                    setQuestionDetail(res?.data?.evaluationInfo)
                    setQuestionList(res?.data?.evaluationInfo?.questions)
                    setEvaluationScore(res?.data?.evaluationInfo?.evaluationScore)
                    setEvaluationType(res?.data?.evaluationInfo?.evaluationType)
                    /**
                     * below logic is for radio button & checkbox
                     * */
                    let arr = new Array(res?.data?.evaluationInfo?.questions?.length);
                    let scArr = new Array(res?.data?.evaluationInfo?.questions?.length)
                    for (let i = 0; i < res?.data?.evaluationInfo?.questions?.length; i++) {
                        arr[i] = new Array(0);

                        if (res?.data?.evaluationInfo?.questions[i]?.type === 18) {
                            scArr[i] = new Array(res?.data?.evaluationInfo?.questions[i]?.options?.length).fill(null)
                            scorecardArr[i] = new Array(res?.data?.evaluationInfo?.questions[i]?.options?.length).fill(null)
                        }

                    }
                    chkArr = arr

                    break
                }
                case 'ats|candidate-evaluation|add': {
                    if (evaluationTypeRef.current === 2) {
                        setShowThankYou(true);
                    }else {
                        handle?.closeModal();
                    }
                    showToastSuccess(
                        evaluationTypeRef.current === 2
                            ? 'Question Bank Added Successfully.'
                            : 'Evaluation Added Successfully.'
                    );
                    break;
                }
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        refresh();
        getRequestedList()
        return () => off();
    }, []);

    const getRequestedList = () => {
        let data = {
            _id: _GEM?._id,
        }
        sendData('ats|candidate-evaluation|fetch', data)
    }

    const handle = {
        submit: (e, type) => {
            let valid = true
            e.preventDefault()
            if (validator?.current?.allValid()) {
                let data = {
                    candidate: _GEM?.candidate,
                    evaluationForm: _GEM?.evaluationForm,
                    user: _ID,
                    questionAnswer: questionList,
                    questionId: questionDetail?.questionId,
                    isInterview: _GEM?.isInterview || false,
                    interviewId: _GEM?.interviewId,
                    requestId: _GEM?._id,
                    evaluationType: evaluationType,
                    requestedBy: questionDetail?.createdBy
                }
                if (EVScore) {
                    data.score = EVScore
                    valid = true
                } else {
                    valid = !evaluationScore?.isMandatory;
                }

                if(EVNote?.length){
                    data.description = EVNote || ""
                    valid = true
                }else if(evaluationScore?.isMandatory && evaluationScore?.isShowNote) {
                    valid = false
                }

                questionList?.map((que, i) => {
                    if (que.type === 18 && que.isMandatory) {
                        if (que?.answer === undefined || que?.answer?.includes(null)) valid = false
                    }
                    if (que.otherAnswer) que.answer = que.otherAnswer
                })
                if (valid) {
                    sendData('ats|candidate-evaluation|add', data)
                }
            } else {
                validator?.current?.showMessages();
                errorFocus();
            }
        },
        change: (e, index, name, type, ele) => {
            let list = JSON.parse(JSON.stringify(questionList)) || []

            for (let i = 0; i < list.length; i++) {
                if (i === index && list[index]) {
                    if (type === 4) {
                        if (e !== 'other-option') {
                            list[index].otherOption = false
                            list[index][name] = [e]
                        } else {
                            list[index].otherOption = true
                            list[index][name] = ''
                        }
                    } else if (type === 5) {
                        if (e === 'other-option') {
                            list[index].otherOption = !list[index].otherOption
                            list[index][name] = chkArr[i]
                            list[index]['otherAnswer'] = chkArr[i]
                        } else {
                            if (ele.target.checked) {
                                if (chkArr[i].indexOf(e) === -1) {
                                    chkArr[i].push(e);
                                }
                            } else {
                                let index = chkArr[i].indexOf(e);
                                if (index > -1) {
                                    chkArr[i].splice(index, 1);
                                }
                            }
                            list[index][name] = chkArr[i]
                            list[index]['otherAnswer'] = chkArr[i]
                        }
                    } else if (type === 6) list[index][name] = [e?.value]
                    else if (type === 7) list[index][name] = [e]
                    else if (type === 9) list[index][name] = e
                    else list[index][name] = e
                }
            }
            setQuestionList(list);
        },
        changeInput: (e, index, name, type) => {
            let list = JSON.parse(JSON.stringify(questionList)) || []
            for (let i = 0; i < list.length; i++) {
                if (i === index && list[index]) {
                    if (type === 4) {
                        list[index][name] = [e]
                        list[index]['otherAnswer'] = chkArr[i]?.concat(e)
                    } else if (type === 5) {
                        // list[index][name] = [e]
                        list[index]['otherAnswer'] = chkArr[i]?.concat(e)
                    }
                }
            }
            setQuestionList(list);
        },
        changeScore: (e, index, name, type, queIndex) => {
            let list = JSON.parse(JSON.stringify(questionList)) || []
            for (let i = 0; i < list.length; i++) {
                if (i === index && list[index]) {
                    if (type === 18) {
                        scorecardArr[index][queIndex] = e;
                        list[index][name] = scorecardArr[index]
                    }
                }
            }
            setQuestionList(list);
        },
        changeEVScore: (e) => {
            setEVScores(e)
        },
        changeEVNote: (e) => {
            setEVNote(e?.target?.value)
        },
        upload: e => {
            setFileLoader(true)
            const body = {
                event: 'hrms|template|question|file|upload',
                data: {
                    candidateId: _GEM?.candidate,
                    templateId: _GEM?.candidate,
                    moduleType: 2 // template: 1, survey: 2
                },
                orgId: _ORG_ID
            };
            const formData = new FormData();
            formData.append('body', Encryption(body));
            formData.append('file', e.target.files[0]);

            const config = {
                headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                onUploadProgress: e => {
                },
            };

            api.post('/hrmsFileUpload', formData, config).then(res => {

            }).catch(error => {
            });
        },
        closeModal: e => {
            DISPATCH({type: 'GIVE_EVALUATION_MODAL', payload: null});
        },
    }

    return (
        <React.Fragment>
            <UModal
                open={true}
                position="right"
                className="u_view-stage-popup u_evaluation-modal"
                onClose={() => handle.closeModal()}
                header={<h4>{evaluationType === EVALUATION_TYPE.QUESTION_BANK ? "Add Question Bank" : "Add Evaluation"}</h4>}
            >
                <div className="u_ats">
                    <div className="u_evaluation-header">
                        <div className="u_evaluation-header-left u_flex-1">
                            <div className="u_flex u_align-center u_flex-1">
                                <div className="u_mr-15 u_pr-15 u_border-right">
                                    <p className="u_small-font u_mb-5 u_color-title">Requested By</p>
                                    <div className="u_flex u_align-center ">
                                        <UAvatar name={getName(_USERS[_GEM?.createdBy])} width={30}/>
                                        <p className="u_small-font u_one-line u_pl-10 u_cp u_color-title">{getName(_USERS[_GEM?.createdBy])}</p>
                                    </div>
                                </div>
                                <div className="">
                                    <p className="u_small-font u_mb-5 u_color-title">Requested on</p>
                                    <span className="u_font u_mt-5"><UDateFormatter date={_GEM?.createdAt} format={FORMAT.MONTH_DATE_TIME}/></span>
                                </div>
                            </div>
                        </div>

                        <div className="u_evaluation-header-right">

                        </div>
                    </div>

                    <div className="vs_preview u_h-full u_flex u_direction-column">
                        <ViewForm loader={loader} uac={true} questionList={questionList} _S3_BASE_URL={_S3_BASE_URL} validator={validator} handle={handle} evaluationScore={evaluationScore} EVNote={EVNote}
                                  fileLoader={fileLoader} fileResponse={fileResponse} EVScore={EVScore} evaluation={true} isSurvey={false} evaluationType={evaluationType} product=" Recruit" submitBtn={evaluationType === EVALUATION_TYPE.QUESTION_BANK ? "Submit" : "Submit Evaluation"}/>
                    </div>

                </div>
            </UModal>
            {showThankYou && evaluationType === EVALUATION_TYPE.QUESTION_BANK && (
                <UModal
                    open={true}
                    maxWidth={450}
                    className="u_apply-popup u_border-radius-8"
                    isHeaderShow={false}
                    onClose={() => {
                        setShowThankYou(false);
                        handle.closeModal();
                    }}
                >
                    <div className="u_p-25 u_text-center">
                        <div className="u_m-auto">
                            <img
                                src="/images/success.png"
                                alt="Thank you"
                                className="u_m-auto"
                            />
                        </div>
                        <h2 className="u_mb-10 u_mt-16">Successfully Submitted</h2>
                        <p className="u_small-font u_mt-16">
                            The question form has been submitted successfully.
                        </p>
                    </div>
                </UModal>
            )}
        </React.Fragment>
    );
});

export default CandidateEvaluationForm;
